import { Link } from '@mui/material'
import Box from '@mui/material/Box'
import { LuneTheme, Text } from 'lune-ui-lib'
import React from 'react'

import FrameLayout from 'components/FrameLayout'

const gradientBg = require('images/gradientBg.png')

const ConflictPage = () => {
    return (
        <FrameLayout>
            <Box
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'stretch',
                    p: 2,
                    pt: 0,
                    a: {
                        textDecoration: 'none !important',
                    },
                }}
            >
                <Box
                    sx={{
                        p: 6,
                        width: '100%',
                        flex: '1 1 auto',
                        borderRadius: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundImage: `url(${gradientBg})`,
                        backgroundPosition: 'center',
                        backgroundSize: 'cover',
                    }}
                >
                    <Box>
                        <Text variant={'h5'} sx={{ mb: 4 }}>
                            It looks like we've processed your payment already.
                        </Text>
                        <Text variant={'body2'} sx={{ mb: 4 }}>
                            <Link
                                href="mailto:support@lune.co"
                                target="_blank"
                                sx={{
                                    color: LuneTheme.palette.Black,
                                    '&:hover': {
                                        textDecoration: 'underline !important',
                                    },
                                }}
                            >
                                Please contact support for help.
                            </Link>
                        </Text>
                    </Box>
                </Box>
            </Box>
        </FrameLayout>
    )
}

export default ConflictPage
